import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { State } from '../../redux/store'
import { AdsInfoInterface, ShowAdsInfoContext, modalType } from './types'
import { useTranslation } from 'react-i18next'
import { formatDate, getRemainingDays } from '../../functions/functions'
import ToggleImages from './ToggleImages'
import { FaEdit } from 'react-icons/fa'
import { MdRemoveCircleOutline } from 'react-icons/md'

const DataAdsInfo = () => {
  const { adsInfos } = useSelector((state: State) => state.adsInfos)
  const { t } = useTranslation()

  const { 
    setSelectedAdsInfo,
    showEditAdsInfoModal, setShowEditAdsInfoModal,
    showDeleteAdsInfoModal, setShowDeleteAdsInfoModal,
    setSelectedModal
  } = useContext(ShowAdsInfoContext)

  const toggleEditModal = (AdsInfo: AdsInfoInterface) => {
    setShowEditAdsInfoModal(!showEditAdsInfoModal)
    setSelectedAdsInfo(AdsInfo)
    setSelectedModal(modalType.EditModal)
  }

  const toggleDeleteModal = (AdsInfo: AdsInfoInterface) => {
    setShowDeleteAdsInfoModal(!showDeleteAdsInfoModal)
    setSelectedAdsInfo(AdsInfo)
    setSelectedModal(modalType.DeleteModal)
  }

  return (
    <div className='grid md:grid-cols-3 gap-2 mt-3'>
      {adsInfos.map((ads: AdsInfoInterface, index: number) => {
        return <section className='bg-white rounded p-2 flex flex-col justify-between' key={index}>
          <ToggleImages ads={ads}/>
          <section>
            <div className='flex justify-between'>
              <b>{t("Titre")}: </b>
              <p>{ads.title}</p>
            </div>
            <div className='flex justify-between'>
              <b>{t("Societe")}: </b>
              <p>{ads.company}</p>
            </div>
            <div className='flex justify-between'>
              <b>{t("Date de fin")}: </b>
              <p>{formatDate(ads.finishDate)}</p>
            </div>
            <div className='flex justify-between'>
              <b>{t("Reste")}: </b>
              <p>{getRemainingDays(ads.finishDate)}</p>
            </div>
          </section>
          <div className='flex justify-center'>
            <FaEdit className='text-second text-2xl' onClick={() => toggleEditModal(ads)} />
            <MdRemoveCircleOutline className='text-red text-2xl' onClick={() => toggleDeleteModal(ads)} />
          </div>
        </section>
      })}
    </div>
  )
}

export default DataAdsInfo